var React = require('react');

function BlueScorpio (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"23.5862 27.0606 20.1194 23.5939 20.1194 8.0271 17.7034 5.6111 16.4632 6.8504 16.4632 23.1333 13.06 23.1333 13.06 8.0271 10.644 5.6111 9.4037 6.8504 9.4037 23.1333 6.0005 23.1333 6.0005 8.0271 3.5845 5.6111 2.0179 7.1768 .4441 5.6029 4.7603 1.2858 8.2905 4.816 11.8198 1.2858 15.35 4.816 18.8802 1.2858 23.5227 5.9293 23.5227 21.4952 24.762 22.7354 26.3286 21.1697 27.9024 22.7435 23.5862 27.0606","fill":"#f2e8b9","strokeWidth":"0"}));
}

BlueScorpio.defaultProps = {"id":"Layer_1","data-name":"Layer 1","version":"1.1","viewBox":"0 0 28.3465 28.3465"};

module.exports = BlueScorpio;

BlueScorpio.default = BlueScorpio;
